import { Navigate } from 'react-router-dom';
import { useUnifiedAuth } from '@/contexts/UnifiedAuthContext';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

interface Props {
  children: React.ReactNode;
  requiredRole?: string;
  requiredRoles?: string[];
}

export function UnifiedProtectedRoute({ children, requiredRole, requiredRoles }: Props) {
  const { user, loading, hasRole } = useUnifiedAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/app/login" replace />;
  }

  const roleOk = requiredRoles?.length
    ? requiredRoles.some(r => hasRole(r))
    : requiredRole
    ? hasRole(requiredRole)
    : true;

  if (!roleOk) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-[#FDD238] mb-2">403</h1>
          <p className="text-white text-lg">No tienes acceso a esta sección</p>
          <button
            onClick={() => window.history.back()}
            className="mt-4 px-4 py-2 bg-[#FDD238] text-black rounded font-medium hover:bg-yellow-300 transition"
          >
            Volver
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
